export const locale = {
  lang: 'tr',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'INST_1': 'Soru şablonunu indirin',
         'INST_2': 'Şablonda gerekli değişiklikleri yapın',
         'INST_3': 'Soru şablonunu yükleyin',
         'BTN_DESC_PLAN': 'Soru Şablonu',
         'BUSC_PLAN_TEX': 'Şablon sorularını aramak için burayı tıklayın',
         'TEMP_CARG_TIT': 'Şablon bilgisi',
         'TOT_PREG': 'Toplam sorular',
         'TOT_PREG_MODI': 'Toplam değiştirilmiş sorular',
         'TOT_PREG_NUE': 'Toplam yeni sorular',
         'TEMP_CARG_TIT_CAR': 'Şablon bilgisi yüklendi',
         'COMPL_PAS_SIN_MODI': 'Henüz herhangi bir değişiklik yapmadınız. Adımı tamamlayacağınızdan emin olabilirsiniz? ',
         'SUCC_CAR_PLAN': 'Şablon başarıyla yüklendi. Lütfen adımı tamamlayın',
         'COMPLE_PASO_CON_MODI': 'Şu anda girilen değişikliklerle adımı tamamladığınızdan emin misiniz?',
         'NO_MODIF':'Bu hücre içeriğini değiştirmeyin',
         'ERROR_CARGA': 'Dosya yüklenemiyor, bir veya daha fazla kısıtlanmış hücrede değişiklikler tespit edildi, şablonu tekrar indirip kısıtlı hücreleri değiştirmeden istenen değişiklikleri yapın.\n\nKısıtlanmış hücreler, içeriklerinin değiştirilmemesi gerektiğini belirten bir yorum içerir',
         'FORALL_EXCEDIDAS': 'Yüklenen şablonda bulunan 4All uygulamalarının sayısının izin verilen uygulama sayısını aştığı tespit edildi, yalnızca izin verilen maksimum değere karşılık gelen uygulamalar yüklendi ',
         'OPCIONDEMOGRAFICOS': 'Bu hücre, demografik katalog sayfasından değişmeyen bir değer içermelidir',
         'CARGANDO_PREGUNTAS': 'Şablondan sorular yükleniyor'
      },
      'CATALOGO_IDIOMAS':{
      'z1': 'Basitleştirilmiş Çince',
       'z2': 'Geleneksel Çince',
       'ko': 'Korece',
       'ja': 'Japonca',
       'pt': 'Portekizce',
       'en': 'İngilizce',
       'fr': 'Fransızca',
       'de': 'Almanca',
       'it': 'İtalyanca',
       'es': 'İspanyolca',
       'tr': 'Türkçe',
       'ms': 'Malayca',
       'ro': 'Romence',
       'vi': 'Vietnamca',
       'bg': 'Bulgarca',
       'merhaba': 'Hintçe',
       'ru': 'Rusça',
       'mn': 'Moğol',
       'nl': 'Flemenkçe',
       'ar': 'Arap',
       'ua': 'Ukrayna',
       'id': 'Endonezya dili',
      },
      'HOJAS_EXCEL':{
        'Instrucciones': 'Talimatlar',
        'Catalogo': 'Katalog',
        'Detalles': 'Ayrıntılar',
        'CatDemograficos': 'Demografik Katalog',
        'Nps': 'Nps',
        'Reactivos': 'İfadeler',
        'Control': 'Control',
        'Demograficos': 'Demografi',
        'Abiertas': 'Açık',
        'Forall': 'Forall',
        'Adicionales': 'Ek',
     },
     'COLUMNAS_H_CATA':{
     'ClaveIdiomas': 'LanguageKey',
      'NombreIdiomas': 'DilAdı',
      'IDTipoPregunta': 'Soru türü kimliği',
      'TiposPreguntas': 'Soru türleri',
      'ClaveTipoElemento': 'Öğe türü anahtarı',
      'TiposElementos': 'Eleman türleri',
       'CONTEM_TIP_PREG':{
       '1': 'NPS / Kontrol / Ek soru (çoktan seçmeli, tek cevap)',
        '2_1': 'NPS / Kontrol / açık uçlu soru, açık metin türü',
        '2_2': 'NPS / Kontrol / açık uçlu soru, sayısal metin türü',
        '3': 'Reaktif tür sorusu',
        '4': 'Demografik tip soru (çoktan seçmeli, tek cevap)',
        '5': '4All Pratiği Yap',
        '6': 'Ek soru (çoktan seçmeli, çok cevaplı)',
       },
       'CONTEM_TIP_SEGM':{
         'question': 'Soru metni',
          'answer_1': 'Cevap 1 in metni',
          'answer_2': 'Cevap 2 nin metni',
          'answer_n': 'Cevap n metni',
          'practice': 'Uygulama metni 4All',
          'description': 'Uygulama 4All açıklama metni',
          'statement_1': 'Soru 1 uygulama 4All',
          'statement_2': 'Soru 2 uygulama 4All',
       }
     },
     'COLUMNAS_SECCION':{
      'Id':	'Yaptım',
      'TipoDePregunta': 'Soru Tipi',
       'PalabrasClave': 'Anahtar Kelimeler',
       'NuevaPregunta': 'NewQuestion',
       'Eliminable': 'Elimine Edilebilir',
       'Editable': 'Düzenlenebilir',
       'RespuestaObligatoria': 'Zorunlu Cevap',
       'MostrarPregunta': 'ShowQuestion',
      'Dimension': "Boyut",
       'Competencia': 'Yetkinlik',
       'Subcompetencia': 'Alt Yeterlilik',
       'TipoDemografico': 'TypeDemographic',
      'practice':	'pratik',
      'description':	'açıklama',
      'statement_1':	'ifade_1',
      'statement_2':	'ifade_2',
      'question':	'soru',
      'answer':	'answer',
      'OpcionOtro': 'Cevap türü "Diğer"'

     }
    }
  }
};
